import h from 'react-hyperscript';

import './TalkBusiness.css';

const TalkBusiness = () => h('.business-talking', [h('h2', "Let's Talk Business")]);

export default TalkBusiness;



// WEBPACK FOOTER //
// ./src/components/Sections/TalkBusiness/TalkBusiness.js